import $ from "jquery";
import "slick-slider";

import "./topbar";
import "./cookie-consent";
import "../styles/features.scss";

const featureNameIndexMap = {
  "single-interface": 1,
  "source-code-ownership": 2,
  "building-and-storing-artifacts": 3,
  "release-management": 4,
  "compute-resource-management": 5,
  "monitoring-performance-and-availability": 6,
  "backup-and-restore": 7,
  audit: 8,
  integrations: 9,
  issues: 10,
  sso: 11,
  "users-management": 12,
  notifications: 13,
  documents: 14,
};
const carouselConfig = {
  infinite: true,
  prevArrow: $(".prev-feature"),
  nextArrow: $(".next-feature"),
  slidesToShow: 4,
  slidesToScroll: 4,
  swipe: false,
  swipeToSlide: false,
  touchMove: false,
  draggable: false,
  responsive: [
    {
      breakpoint: 1440,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 1080,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: true,
        swipeToSlide: true,
      },
    },
  ],
};
let isCarouselInitialized = false;

const getQueryParams = () => new URLSearchParams(window.location.search);
const getFeatureNameByIndex = (featureIndex) =>
  Object.keys(featureNameIndexMap).find(
    (key) => featureNameIndexMap[key] === featureIndex
  );

const setQueryParams = (key, value) => {
  if ("URLSearchParams" in window) {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set(key, String(value));
    const newRelativePathQuery =
      window.location.pathname + "?" + searchParams.toString();
    window.history.pushState({ [key]: value }, "", newRelativePathQuery);
  }
};

const setFeatureMetaTags = (featureIndex) => {
  const featureId = `#feature-${featureIndex}`;
  const featureTitle =
    $(`${featureId} .features-title`)?.text() || "Возможности платформы «Гиперион»";
  const featureDescription =
    $(`${featureId} .features-container > p`)?.text() ||
    "Платформа «Гиперион» — управление жизненным циклом ПО.";

  document.title = featureTitle;
  $('meta[name="description"]').attr("content", featureDescription);
  $("#itemprop-name").attr("content", featureTitle);
  $("#itemprop-description").attr("content", featureDescription);
  $("#twitter-title").attr("content", featureTitle);
  $("#twitter-description").attr("content", featureDescription);
  $("#twitter-site").attr("content", window.location.href);
  $("#og-title").attr("content", featureTitle);
  $("#og-description").attr("content", featureDescription);
  $("#og-url").attr("content", window.location.href);
};

const hideContent = (content) => content?.addClass("d-none");
const showContent = (content) => content?.removeClass("d-none");
const setupCarousel = () => {
  if (!isCarouselInitialized) {
    setTimeout(() => $(".feature-list-slider").slick(carouselConfig));
    isCarouselInitialized = true;
  }
};

const isFeatureIndexExists = (featureIndex) =>
  Object.keys(featureNameIndexMap).some(
    (key) => featureNameIndexMap[key] === featureIndex
  );
const setSelectedMenuItem = (featureIndex) => {
  Object.keys(featureNameIndexMap).forEach((key) => {
    const featureLink = $(`#feature-${featureNameIndexMap[key]}-link`);

    if (featureNameIndexMap[key] === featureIndex) {
      featureLink.addClass("current");
    } else {
      featureLink.removeClass("current");
    }
  });
};

window.onSelectFeature = (featureIndex) => {
  const featureList = $("#feature-list");
  const featureDetails = $("#feature-details");

  if (!isFeatureIndexExists(featureIndex)) {
    showContent(featureList);
    hideContent(featureDetails);

    return;
  }

  const feature = $(`#feature-${featureIndex}`);

  if (!feature.length) {
    showContent(featureList);
    hideContent(featureDetails);

    return;
  }

  Object.keys(featureNameIndexMap).forEach((key) => {
    hideContent($(`#feature-${featureNameIndexMap[key]}`));
  });

  setupCarousel();
  showContent(featureDetails);
  hideContent(featureList);
  setQueryParams("feature", getFeatureNameByIndex(featureIndex));
  setFeatureMetaTags(featureIndex);
  setSelectedMenuItem(featureIndex);
  showContent(feature);
  window.scrollTo(0, 0);
};

$(document).ready(() => {
  window.onSelectFeature(featureNameIndexMap[getQueryParams().get("feature")]);

  window.addEventListener("popstate", function () {
    window.onSelectFeature(
      featureNameIndexMap[getQueryParams().get("feature")]
    );
  });
});
